import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'opac-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  /**
   * Sets the accept button label
   */
  @Input() acceptLabel: string = 'common.accept';
  /**
   * Sets the cancel button label
   */
  @Input() cancelLabel: string = 'common.cancel';
  /**
   * Determines if the dialog is open
   */
  @Input() open = false;
  /**
   * Dialog title
   */
  @Input() title: string = '';

  /**
   * Emits when the accept button is clicked
   */
  @Output() accept = new EventEmitter<void>();
  /**
   * Emits when the cancel or close button is clicked
   */
  @Output() cancel = new EventEmitter<void>();
}
